const HTML_TAG_PATTERN = /<[a-z][^>]*>/i;

export function shouldRenderNotificationAsHtml(
  notificationType: string | null,
  content: string,
): boolean {
  return notificationType === "email" && HTML_TAG_PATTERN.test(content);
}
